import { render, staticRenderFns } from "./PostTop.vue?vue&type=template&id=07a9e186&scoped=true&"
import script from "./PostTop.vue?vue&type=script&lang=js&"
export * from "./PostTop.vue?vue&type=script&lang=js&"
import style0 from "./PostTop.vue?vue&type=style&index=0&id=07a9e186&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a9e186",
  null
  
)

export default component.exports